let namespace = '';

export const setFieldBuilderNamespace = (ns: string): void => {
  namespace = ns;
};

export const getFieldBuilderNamespace = (): string => namespace;
